import { ProductDTO } from '@/abstract'

export class HostingDTO extends ProductDTO {}
